import {Injectable} from '@angular/core';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';
import { IRequestValidateDocument } from './file-upload.model';

@Injectable()
export class FileUploadMappingService {

  constructor(
    private secureStorageService: SecureStorageService
  ){}


  prepareDataRequestValidateDocument(documento: string, tipoDocumento: string): IRequestValidateDocument {
    const idTracking = this.secureStorageService.getData("IdTracking");
    const companyId = this.secureStorageService.getData("CompanyId");
    return {
        TrackingId: idTracking,
        CompanyId: companyId,
        tipoDocumento: documento ?? "",
        documento: tipoDocumento ?? "",
    };
  }



}
